/* eslint-disable no-else-return,func-names,no-return-assign,no-plusplus */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable valid-typeof */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-use-before-define */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable radix */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useState, useEffect, useRef, useContext,
} from 'react';
// analytics
import ReactGA from 'react-ga';
import { Link, useParams } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Cookies from 'js-cookie';
import {
  Grid,
  Typography,
  useMediaQuery,
  Avatar,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import { UserContext } from '@context/UserContext';
import axios from '@shared/config/baseAPI';
import FormData from 'form-data';
import { useLastLocation } from 'react-router-last-location';

import {
  MangoLevel, Badge, LikeButton, CommentInputField, SendCommentButton, FollowButton,
} from '@shared/components';
import VideoCard from '@shared/components/VideoCard/VideoCard';
import Pagination from '@shared/components/Pagination/Pagination';
import {
  getKlipComments, getUser, getSelectedKlip, getUserKlips,
} from '@shared/services/userApi';
import NumberFormatter from '@shared/utils/NumberFormatter';
import './ShortVideo.css';
import heart from '@assets/images/klips/heart.png';
import commentIcon from '@assets/images/klips/comment.png';
import share from '@assets/images/klips/share.png';
import StringTruncate from '@shared/utils/StringTruncate';

// New Login Modal Component
// added libraries

import KlipPlayer from '@features/ShortVideoPlayer/components/ShortVideoPlayer';
import BanUser from '@features/UserAccountBan';
import LockUser from '@features/UserAccountLock';

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: '#FFF',
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

function CustomScrollbars(props) {
  return (
    <Scrollbars
      renderThumbHorizontal={renderThumb}
      renderThumbVertical={renderThumb}
      {...props}
    />
  );
}

function ShortVideo() {
  const { username, id } = useParams();
  const [user, setUser] = useState([]);
  const [guid, setGuid] = useState('');
  const [userFound, setUserFound] = useState(false);
  const [klips, setKlips] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const [videoData, setVideoData] = useState([]);

  // pagination
  const [page, setPage] = useState(1);
  const [pageSize] = useState(12);
  const [totalPages, setTotalPages] = useState();

  // comment section
  const [isLike, setIsLike] = useState('');
  const [likeCount, setLikeCount] = useState('');
  const [commentCount, setCommentCount] = useState('');
  const [shareCount, setShareCount] = useState('');

  // check if user is loggedin
  const userToken = Cookies.get('token'); // token from cookies
  const { loggedIn, setLoggedIn } = useContext(UserContext); // profile data - store

  // API Request
  const [banModalStatus, setBanModalStatus] = useState(false);
  const [userBanDetails, setUserBanDetails] = useState([]);

  const deviceId = Cookies.get('deviceId'); // change this with your device id
  const formData = new FormData();

  // get comments
  const [commentList, setCommentList] = useState([]);
  const [commentsFound, setCommentsFound] = useState('');
  const [sinceId, setSinceID] = useState('');
  const [nextPage, setNextPage] = useState(1);
  const [hide, setHide] = useState(true);

  const getCustomScrollDiv = () => {
    if (typeof document !== 'undefined') {
      return document.getElementById('customScrollDiv');
    }
  };

  const scrollBar = getCustomScrollDiv();
  const customWidthVal = true;
  function callLikeKlip() {
    formData.append('feed_id', id);
    axios.post('/feed/like', formData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded-', 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } })
      .then(((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            setIsLike(true);
            setLikeCount(likeCount + 1);
          }
        }
      }))
      .catch((error) => {
        console.error(error);
      });
  }

  function callUnlikeKlip() {
    formData.append('feed_id', id);
    axios.post('/feed/unlike', formData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded-', 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } })
      .then(((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            setIsLike(false);
            setLikeCount(likeCount - 1);
          }
        }
      }))
      .catch((error) => {
        console.error(error);
      });
  }

  function getKlipsCommentFunc(commentVal) {
    getKlipComments(id, nextPage, sinceId)
      .then((klipCommentsRes) => {
        for (const k in klips) {
          if (klips.hasOwnProperty(k) && id === klips[k].feed_id) {
            setIsLike(klips[k].is_like);
            setLikeCount(klips[k].like_count);
            setShareCount(klips[k].share_count);
          }
        }
        setCommentCount(commentCount + 1);
        if (klipCommentsRes.status === 200) {
          if (klipCommentsRes.data.code === '200' && klipCommentsRes.data.data.list.length !== 0) {
            const newComment = [{
              content: commentVal,
              time: Date.parse(new Date()) / 1000,
              user_info: {
                avatar_small: loggedIn.avatar,
                intro: loggedIn.intro,
                guid: loggedIn.guid,
                nickname: loggedIn.nickname,
                username: loggedIn.username,
                type: loggedIn.type,
              },
            }];
            const comment = newComment.concat(commentList);
            setCommentList(comment);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function callLeaveComment() {
    formData.append('feed_id', id);
    if (commentValue !== '') {
      formData.append('content', commentValue);
      if (Cookies.get('token')) {
        axios.post('/feed/comment', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${Cookies.get('token')}` } })
          .then(((response) => {
            if (response.status === 200) {
              if (response.data.code === '200') {
                commentInput.current.value = '';
                setCommentValue('');
                getKlipsCommentFunc(commentValue);
              }
            }
          }))
          .catch((error) => {
            console.error(error);
          });
      }
    } else {
      swalWithButtons.fire({
        title: '<small class="titles">Warning</small>',
        text: 'Comment is required',
        confirmButtonText: 'Okay',
      });
    }
  }

  const checkBanStatus = async (actionTodo) => {
    if (loggedIn.user_status === 'ban' || loggedIn.user_status === 'lock') {
      setBanModalStatus(true);
    } else if (loggedIn.user_status === 'normal') {
      if (actionTodo === 'like') {
        if (Cookies.get('token')) {
          if (!isLike) {
            callLikeKlip();
          } else {
            callUnlikeKlip();
          }
        }
      } else if (actionTodo === 'comment') {
        callLeaveComment();
      }
    }
  };

  // update loggedin user profile
  const loggedInUpdate = async (actionToDo) => { // action to do = like, comment or share
    getUser(loggedIn.username)
      .then(async (userRes) => {
        if (userRes.data.code === '200') {
          setLoggedIn(userRes.data.data);
          setUserBanDetails(userRes.data.data.banDetails);
          await checkBanStatus(actionToDo);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getUser(username)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            setUser(response.data.data);
            setGuid(response.data.data.guid);
            setUserFound(true);
            setNextPage(1);
            setSinceID('');
            setHide(true); // hide load more button
          } else {
            setUserFound(false);
          } // End if
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [username]);

  const lastLocation = useLastLocation();
  function navigationType() {
    let navigationResult = '';
    let redirect;
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (window.performance.getEntriesByType('navigation')) {
        redirect = window.performance.getEntriesByType('navigation')[0].type;
        if (redirect === 'back_forward') { navigationResult = document.referrer; }
        if (redirect === 'navigate') { navigationResult = document.referrer; }
        if (redirect === 'reload') { navigationResult = ''; }
      }
      return navigationResult;
    }
  }
  function sourceTracker() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (lastLocation) {
        return window.location.origin + lastLocation.pathname;
      } else if (document.referrer !== '') {
        return navigationType();
      }
      return 'Others';
    }
  }
  function sourceNameTracker() {
    const location = sourceTracker();
    if (location === `${window.location.origin}/search/index`) {
      return 'Search';
    } else if (location === `${window.location.origin}/${username}/klips/${videoData.fid}`) {
      return 'Klips';
    } else if (location === `${window.location.origin}/${username}`) {
      return 'User Profile';
    } else if (location === `${window.location.origin}/klips`) {
      return 'Browse';
    } else {
      return 'Browse Category';
    }
  }

  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    const pageNumber = Cookies.get('short_video_page');
    const position = Cookies.get('short_video_position');
    getSelectedKlip(id)
      .then((response) => {
        const klipType = () => {
          if (response.data.data.product_ids) {
            return 'E-Commerce';
          }
          return 'Regular';
        };
        const isKlipFeatured = () => user.type === 1;
        const isKlipFollowing = () => user.relation_status === 5 || user.relation_status === 1;
        if (response.status === 200) {
          const dataArr = response.data.data;
          dataArr.name = username;
          setVideoData(dataArr);
          if (isNaN(Cookies.get('page_num'))) {
            Cookies.set('page_num', 1);
            setPage(Cookies.get('page_num'));
          }
          setNextPage(1);
          setSinceID('');
          setHide(true); // hide load more button
        }
        window.analytics.track('Short Video Watched', {
          klips_title: response.data.data.cnt,
          host_id: response.data.data.uid,
          feed_id: response.data.data.fid,
          source: sourceNameTracker(),
          featured: isKlipFeatured(),
          following: isKlipFollowing(),
          short_video_type: klipType(),
          position,
          page_number: pageNumber,
          views: response.data.data.replay,
          likes: response.data.data.like,
          comments: response.data.data.cmnt,
          shares: response.data.data.share,
          tags: response.data.data.tag.split(','),
          duration: response.data.data.dur,
          is_autoplayed: 'yes',
        });
      }).catch((error) => {
        console.error(error);
      });
  }, [id, username]);

  function setKlipsFunc(feedVal) {
    if (feedVal) {
      setKlips(feedVal);
      for (const f in feedVal) {
        if (feedVal.hasOwnProperty(f) && id === feedVal[f].feed_id) {
          setIsLike(feedVal[f].is_like);
          setLikeCount(feedVal[f].like_count);
          setCommentCount(feedVal[f].comment_count);
          setShareCount(feedVal[f].share_count);
        }
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }

  useEffect(() => {
    if (guid !== '' && guid !== typeof undefined) {
      getUserKlips(guid, page, pageSize)
        .then((response) => {
          setLoading(true);
          if (response.data.code === '200') {
            setTotalPages(response.data.data.total_pages);
            Cookies.set('totalPages', response.data.data.total_pages);
            if (Cookies.get('totalPages') < page) {
              setPage(1);
            }
            const feed = response.data.data.list;
            setKlipsFunc(feed);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } // End If
  }, [guid, page]);

  useEffect(() => {
    for (const k in klips) {
      if (klips.hasOwnProperty(k) && id === klips[k].feed_id) {
        setIsLike(klips[k].is_like);
        setLikeCount(klips[k].like_count);
        setCommentCount(klips[k].comment_count);
        setShareCount(klips[k].share_count);
      }
    }

    Cookies.set('page_num', page);
    setPage(parseInt(Cookies.get('page_num')));
  }, [id, klips, page]);

  useEffect(() => {
    getKlipComments(id)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            setCommentList(response.data.data.list);
            setCommentsFound(true);
            setNextPage(1);
            if (response.data.data.since_id !== '[]') {
              setSinceID(`"${response.data.data.since_id}"`);
            }
            if (response.data.data.total_pages <= 1) {
              setHide(true); // hide load more button
            } else {
              setHide(false);
            }
            scrollBar.childNodes[0].scrollTo({ top: 0, behavior: 'smooth' }); // scroll to top comment
          } else {
            setCommentsFound(false);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [id]);

  // like klip
  async function likeKlip(likeAction = 'like') {
    await loggedInUpdate(likeAction);
  }
  // google analytics
  useEffect(() => {
    if (typeof window !== 'undefined') {
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview(window.location.pathname);
    }
  }, []);
  function Comments({ comment, index }) {
    return (
      <div key={index} className='user-comment'>
        <div className='userImage-holder'><a href={hostUrl + comment.user_info.username}><img src={comment.user_info.avatar_small} className='user-image' alt='user avatar' /></a></div>
        <div className='comment-text'>
          <a href={hostUrl + comment.user_info.username}>
            <Typography style={{ color: '#29efe9' }}>{StringTruncate(comment.user_info.username, 16)}</Typography>
          </a>

          <Typography>{comment.content}</Typography>
        </div>
        <div className='timestamp'>
          <Typography>{timeAgo(comment.time)}</Typography>
        </div>
      </div>
    );
  }

  const loadMoreComments = () => {
    getKlipComments(id, nextPage + 1, sinceId)
      .then((loadMore) => {
        if (loadMore.status === 200) {
          if (loadMore.data.code === '200') {
            if (sinceId !== '"[]"') {
              setNextPage(nextPage + 1);
              setSinceID(`"${loadMore.data.data.since_id}"`);
              const newComments = loadMore.data.data.list;
              const comments = commentList.concat(newComments);
              setCommentList(comments);

              if (nextPage + 1 === loadMore.data.data.total_pages) {
                setHide(true); // hide load more button
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // leave comment swal
  const swalWithButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn-okay',
    },
    buttonsStyling: false,
  });

  const commentInput = useRef(0);
  const [btnDisable, setIsBtnDisable] = useState(true);
  const [commentValue, setCommentValue] = useState('');
  const handleInputChange = () => {
    if (loggedIn.length === 0) {
      commentInput.current.value = '';
      commentInput.current.disabled = true;
    } else {
      setCommentValue(commentInput.current.value);
      if (commentInput.current.value.length >= 100) {
        swalWithButtons.fire({
          title: '<small class="titles">Warning</small>',
          text: 'Max of 100 characters only',
          confirmButtonText: 'Okay',
        });
      }
      if (commentValue !== '') {
        setIsBtnDisable(false);
      } else {
        setIsBtnDisable(true);
      }
    }
  };

  async function leaveComment(commentAction = 'comment') {
    await loggedInUpdate(commentAction);
  }

  function timeAgo(ts) {
    const d = new Date(); // Gets the current time
    const nowTs = Math.floor(d.getTime() / 1000);
    const seconds = nowTs - ts;

    // more than two days
    if (seconds > 2 * 24 * 3600) {
      return 'a few days ago';
    }
    // a day
    if (seconds > 24 * 3600) {
      return 'yesterday';
    }
    if (seconds > 3600) {
      return 'a few hours ago';
    }
    if (seconds === 3600) {
      return 'a hour ago';
    }
    if (seconds > 60) {
      return `${Math.floor(seconds / 60)} minutes ago`;
    }
    if (seconds === 60) {
      return 'a minute ago';
    }
    if (seconds <= 1) {
      return 'a second ago';
    }
    if (seconds >= 1 && seconds < 60) {
      return `${Math.floor(seconds / 60)} seconds ago`;
    }
  }

  const keyPress = (event) => {
    if (event.key === 'Enter') {
      loggedInUpdate('comment');
    }
  };

  let hostUrl = '/';
  if (process.env.REACT_APP_ENABLE_KL1 === 'true') {
    hostUrl = process.env.REACT_APP_KL1_BASE_URL;
  }
  const usernameLink = hostUrl + user.username;

  const renderSendComment = () => {
    if (Object.entries(loggedIn).length === 0) {
      return <SendCommentButton loggedIn />;
    } else if (!btnDisable) {
      return <SendCommentButton loggedIn={false} leaveComment={leaveComment} submit='submit' />;
    }
    return <SendCommentButton disabled />;
  };

  const renderBanOrLockModal = () => {
    if (loggedIn.user_status === 'ban') {
      return (<BanUser banModalStatus={banModalStatus} userBanDetails={userBanDetails} />);
    } else if (loggedIn.user_status === 'lock') {
      return (<LockUser banModalStatus={banModalStatus} />);
    }
  };

  const counter = (function () {
    let count = 1;
    return function () {
      return count++;
    };
  }());

  const loadShortVideo = (counterValue, idValue) => {
    const element = document.getElementById(idValue).parentNode.parentNode;
    Cookies.set('short_video_position', element.id);
    Cookies.set('short_video_page', page);
    window.scrollTo(0, 0);
  };

  const renderKlipList = () => {
    if (klips && typeof window !== 'undefined') {
      return (
        <>
          <Grid container className='klips-list-container'>
            {klips.map((klip, index) => (
              <>
                {klip.feed_id !== id
                  ? (
                    <Grid item container lg={2} md={3} sm={4} xs={6} id={counter()}>
                      <div className='klips-item-inner'>
                        <Link
                          key={index}
                          id={klip.feed_id}
                          to={`/${user.username}/klips/${klip.feed_id}`}
                          onClick={() => loadShortVideo(counter(), klip.feed_id)}
                        >
                          <VideoCard klip={klip} customWidth={customWidthVal} />
                        </Link>
                      </div>
                    </Grid>
                  )
                  : ''}
              </>
            ))}
          </Grid>

          {totalPages && totalPages !== 1
            ? (
              <Grid container alignItems='center' justifyContent='center' className='pagination-klips' style={{ marginTop: '20px' }}>
                <Pagination totalPages={totalPages} setPage={setPage} page={page} />
              </Grid>
            )
            : ''}

          { banModalStatus === true ? renderBanOrLockModal() : '' }
        </>
      );
    }
    return (
      <Typography>No klips available.</Typography>
    );
  };

  const renderLoadMoreBtn = () => {
    if (hide !== true) {
      return <button className='loadMoreBtn' onClick={() => loadMoreComments()}>View previous comments</button>;
    }
    return '';
  };

  const renderCommentSection = () => (
    <Grid item className='comment-section' xs={12} sm={12} md={5} lg={4} xl={3}>
      <div className='comment-header'>
        <h2 className='title-header comment'>Comments</h2>
      </div>
      <div className='comment-body'>
        <CustomScrollbars autoHide id='customScrollDiv' autoHideTimeout={1000} autoHideDuration={500}>
          { commentsFound === true
            ? (
              <>
                {commentList.map((comment, index) => (
                  <Comments comment={comment} index={index} />
                ))}
                {renderLoadMoreBtn()}
              </>
            )
            : (
              <div className='no-comment'>
                <div className='comment-text'>
                  <Typography>no comments available.</Typography>
                </div>
              </div>
            )}

        </CustomScrollbars>
        <Grid container className='comment-form'>
          <Grid item className='comment-input'>

            {Object.entries(loggedIn).length === 0
              ? <CommentInputField loggedIn commentInput={commentInput} maxLength={0} />
              : (
                <CommentInputField
                  loggedIn={false}
                  commentInput={commentInput}
                  maxLength={100}
                  handleInputChange={handleInputChange}
                  keyPress={keyPress}
                />
              )}
          </Grid>
          {renderSendComment()}
        </Grid>
      </div>
      <Grid container className='comment-footer'>
        <Grid item className='act-left'>
          <div>

            <img src={heart} className='actions likes' alt='heart' />
            <span className='count'>{NumberFormatter(likeCount)}</span>
          </div>
          <div>
            <img src={commentIcon} className='actions comments' alt='comment' />
            <span className='count'>{NumberFormatter(commentCount)}</span>
          </div>
          <div>
            <img src={share} className='actions shares' alt='share' />
            <span className='count'>{NumberFormatter(shareCount)}</span>
          </div>
        </Grid>
        <Grid item>
          {
            Object.entries(loggedIn).length === 0
              ? <LikeButton likeStatus={isLike} loggedIn />
              : <LikeButton likeStatus={isLike} likeKlip={likeKlip} loggedIn={false} />
          }
        </Grid>
      </Grid>
    </Grid>
  );

  const userComponent = () => {
    if (userFound === false) {
      return (
        <div style={{
          margin: '60px', width: '90%', height: '500px', background: 'linear-gradient(0deg, rgba(255,255,255,.0566632), rgba(255,255,255,.0566632)), rgba(255,255,255,.0001)', mixBlendMode: 'normal', opacity: '1', borderRadius: '12px',
        }}
        >
          <p>User not found.</p>
        </div>
      );
    }
    return (
      <Grid container className='klip-top-section'>
        <Grid item xs={12} sm={12} md={7} lg={8} xl={9} className='klip-video'>
          {videoData
            ? (
              <>
                <KlipPlayer data={videoData} />
                <Typography className='video-content'>
                  {videoData.cnt}
                </Typography>
              </>
            )
            : <div><Typography>Klip not available.</Typography></div>}

          <Grid container className='profile-header' alignItems='center' style={{ padding: '0 5px' }}>
            <div className='avatar' style={isMobile ? { marginRight: '14px' } : { marginRight: '18px' }}>
              <a href={usernameLink}>
                {isExtraSmall ? <Avatar className='profile-avatar' src={user.avatar} style={{ height: '35px', width: '35px' }} /> : <Avatar className='profile-avatar' src={user.avatar} style={{ height: '66px', width: '67px' }} /> }
              </a>
            </div>
            <div style={{ marginTop: '8px' }}>
              <Grid container alignItems='center' justifyContent='flex-start'>
                <Grid item>
                  <a href={usernameLink}>
                    <Typography style={isMobile ? {
                      fontSize: '11pt', fontWeight: 'bold', letterSpacing: '0.8px', color: '#FB2961',
                    } : {
                      fontSize: '15pt', fontWeight: 'bold', letterSpacing: '0.8px', color: '#FB2961',
                    }}
                    >

                      {isExtraSmall ? StringTruncate(user.nickname, 10) : user.nickname}
                    </Typography>
                  </a>

                </Grid>
                <Grid item>
                  {user.type === 1
                          && (
                            <>
                              {' '}
                              &nbsp;&nbsp;
                              { isExtraSmall
                                ? (
                                  <Badge
                                    type={user.type}
                                    tier={user.tier}
                                    tier_icon={user.tier_icon}
                                    width={15}
                                  />
                                )
                                : (
                                  <Badge
                                    type={user.type}
                                    tier={user.tier}
                                    tier_icon={user.tier_icon}
                                    width={22}
                                  />
                                ) }
                            </>
                          )}
                  {isExtraSmall
                    ? (
                      <MangoLevel
                        level={user.level}
                        width={15}
                      />
                    )
                    : (
                      <MangoLevel
                        level={user.level}
                        width={18}
                      />
                    )}
                </Grid>
              </Grid>
              <a href={usernameLink}>
                <Typography style={isExtraSmall ? { fontSize: '13px' } : { fontSize: '16px' }}>{isExtraSmall ? StringTruncate(user.username, 14) : user.username}</Typography>
              </a>
              <Grid container alignItems='center' justifyContent='flex-start'>
                {isMobile
                  ? (
                    <Typography id='flwrs-title'>
                      {NumberFormatter(user.follower_number, 3)}
                        &nbsp;followers
                    </Typography>
                  )
                  : (
                    <Typography>
                      {NumberFormatter(user.follower_number, 3)}
                        &nbsp;followers
                    </Typography>
                  )}
              </Grid>
            </div>

            {loggedIn.guid === user.guid ? '' : <FollowButton data={user} fid={videoData.fid} />}

          </Grid>
        </Grid>

        {renderCommentSection()}
      </Grid>
    );
  };

  return (
    <div className='klips-holder'>
      {isLoading
        ? <div className='loader-shortvideos-player' />
        : (
          <>
            {userComponent()}
            {renderKlipList()}
          </>
        )}
    </div>
  );
}

export default ShortVideo;
